import { render } from "./ShowSuccess.vue?vue&type=template&id=3118fed3&scoped=true"
import script from "./ShowSuccess.vue?vue&type=script&lang=js"
export * from "./ShowSuccess.vue?vue&type=script&lang=js"

import "./ShowSuccess.vue?vue&type=style&index=0&id=3118fed3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3118fed3"]])

export default __exports__